import React, { ChangeEvent, ReactNode, useCallback, useEffect, useState } from 'react';

import { Radio } from '@xsolla/ui-core';

import { HorizontalCenterColumnBlock } from '../../../styled';
import { getRandomString } from '../../../utils';
import { FlexBlock, RadioDescription, RadioWrapper } from './style';

type Option = {
  label: ReactNode;
  radioValue: string;
  description?: ReactNode;
  dataTestId?: string;
};

type Props = {
  options: Option[];
  disabled?: boolean;
  name: string;
  defaultValue: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  id?: string;

  // ToDo implement direction of radio group
  direction?: 'column' | 'row';
};

const RadioGroup = ({
  options,
  name,
  disabled = false,
  onChange,
  defaultValue,
  direction,
  id
}: Props): JSX.Element => {
  const [activeRadio, setActiveRadio] = useState<string>(defaultValue);

  useEffect(() => {
    setActiveRadio(defaultValue);
  }, [defaultValue]);

  const HandleRadioGroup = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setActiveRadio(e.target.value);
      if (onChange) {
        onChange(e);
      }
    },
    [onChange]
  );

  return (
    <HorizontalCenterColumnBlock id={id}>
      {options.map(({ label, description, radioValue, dataTestId }, index) => (
        <FlexBlock key={getRandomString()}>
          <RadioWrapper
            isActive={activeRadio === radioValue}
            first={!index}
            last={index === options.length - 1}
            disabled={disabled}>
            <Radio
              disabled={disabled}
              name={name}
              value={radioValue}
              checked={activeRadio === radioValue}
              onChange={HandleRadioGroup}
              data-test-id={dataTestId}>
              {label}
              {description && <RadioDescription>{description}</RadioDescription>}
            </Radio>
          </RadioWrapper>
        </FlexBlock>
      ))}
    </HorizontalCenterColumnBlock>
  );
};

export default RadioGroup;
